import React from "react";
import { connect } from "react-redux";
import * as actions from "../actions/actions";
import getParameterByName from "../legacy/helpers/get_parameter_by_name";

import Carousel from "./nounproject-carousel";
import { CollectionCard } from "./nounproject-collection-card";

class CollectionCarousel extends React.Component {
    componentWillMount() {
        if (this.props.q) {
            this.props.fetchCollections(this.props.q, this.props.creator);
        }
    }

    getCollectionSearchLink() {
        const encodedQuery = encodeURIComponent(this.props.q.trim());
        const total =
            this.props.totalCollections === 1
                ? ""
                : this.props.totalCollections;

        return (
            <p>
                <a
                    href={`/search/collection/?q=${encodedQuery}`}
                    className="collection-show-more"
                >
                    {`View all ${total} collections`}
                </a>
            </p>
        );
    }

    getCarouselCards(collections) {
        const cards = getCollectionCards(collections);
        return addDummyCards(cards);

        function getCollectionCards(cards) {
            return cards.map(collection => (
                <CollectionCard collection={collection} key={collection.id} />
            ));
        }

        function addDummyCards(cards) {
            while (!divisbleBy(cards.length, 3)) {
                cards.push(
                    <div
                        data-test="dummy-card"
                        className="card-item card-dummy"
                        key={`dummy-card-${cards.length}`}
                    />
                );
            }

            return cards;

            function divisbleBy(a, b) {
                return a % b === 0;
            }
        }
    }

    render() {
        const { collections } = this.props;

        if (!collections.length) return null;

        const collectionCards = this.getCarouselCards(collections);

        return (
            <section
                data-test="collection-carousel"
                className="collection-list padding-t-l padding-b-l dark"
            >
                <div className="container">
                    <Carousel
                        items={collectionCards}
                        itemsPerView={3}
                        type={"collections"}
                    />
                </div>
                <div className="container">
                    {this.getCollectionSearchLink()}
                </div>
            </section>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const { collections, totalCollections } = state.collections;
    const { q, creator } = ownProps.location.query;

    return {
        collections,
        totalCollections,
        q,
        creator
    };
};

export const ConnectedComponent = connect(mapStateToProps, {
    fetchCollections: actions.fetchCollections
})(CollectionCarousel);

export default () => {
    const location = {
        query: {
            q: getParameterByName("q"),
            creator: getParameterByName("creator")
        }
    };

    return <ConnectedComponent location={location} />;
};
